import React, { useState } from 'react';
import { ChevronRightIcon, ChevronDownIcon, EyeIcon, EyeSlashIcon, TableCellsIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface MapControlProps {
  label: string;
  toggleVisibility: (toggleOn: boolean) => void;
  toggleContent: (toggleOn: boolean) => void;
}

const MapControl: React.FC<MapControlProps> = ({
  label,
  toggleVisibility,
  toggleContent
}) => {
  const [isChevronEnabled, setIsChevronEnabled] = useState(false);
  const [isEyeEnabled, setIsEyeEnabled] = useState(true);
  const [isTableEnabled, setIsTableEnabled] = useState(false);
  const { t } = useTranslation();


  const toggleChevron = () => {
    setIsChevronEnabled(!isChevronEnabled);
  }

  const toggleEye = () => {
    const newState = !isEyeEnabled;
    setIsEyeEnabled(newState);
    toggleVisibility(newState);
  }

  const toggleTable = () => {
    const newState = !isTableEnabled;
    setIsTableEnabled(newState);
    toggleContent(newState);
  }

  return (
    <div className="mt-4 flex flex-col gap-4 w-full">
      <div className="flex items-center gap-2 w-full">
        <button className="color-black" onClick={toggleChevron}>
          {isChevronEnabled ? (
            <ChevronDownIcon className="h-6 w-6" aria-hidden="true" />
          ) : (
            <ChevronRightIcon className="h-6 w-6" aria-hidden="true" />
          )}
        </button>
        <h2 className="text-md font-bold leading-6 text-gray-900 flex-1">
          {label}
        </h2>
        <button className="color-black" onClick={toggleEye}>
          {isEyeEnabled ? (
            <EyeIcon className="h-6 w-6" aria-hidden="true" />
          ) : (
            <EyeSlashIcon className="h-6 w-6" aria-hidden="true" />
          )}
        </button>
        <button
          className="color-black"
          onClick={toggleTable}
        >
          <TableCellsIcon className="h-6 w-6" aria-hidden="true" />
        </button>
      </div>

      {isChevronEnabled && (
        <div className="flex justify-center items-center w-full h-full">
          <div className="flex items-center gap-2">
            <h3 className="mt-2 text-md font-medium text-gray-700">
              {t('map.none')}
            </h3>
          </div>
        </div>
      )}
    </div>
  );
};

export default MapControl;
